import { FiSearch } from 'react-icons/fi';
import { useLocation } from 'react-router-dom';
import './header.css';

const titles = {
  '/admin/dashboard': 'Dashboard',
  '/admin/categories': 'Categories',
  '/admin/products': 'Products',
  '/admin/orders': 'Orders',
  '/admin/payment-status': 'Payment Status',
  '/admin/invoices': 'Invoice Details',
};

export const AdminHeader = () => {
  const { pathname } = useLocation();
  const title = titles[pathname] || 'Admin';

  return (
    <header className="admin-header">
      <h1 className="admin-header__title">{title}</h1>
      <div className="admin-header__search">
        <FiSearch className="admin-header__search-icon" />
        <input type="text" placeholder={`Search ${title.toLowerCase()}...`} aria-label="Search" readOnly />
      </div>
      <div className="admin-header__right">
        <div className="admin-header__avatar">A</div>
        <span className="admin-header__name">admin</span>
      </div>
    </header>
  );
};
